const setSecondChildrenNationality = (id = null) => {
  return {
    type: 'SET_SECONDCHILDRENNATIONALITY',
    id
  }
}

export default {
  setSecondChildrenNationality,
}
